import React, { useEffect, useState } from "react";
import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import { getAuditColumns } from "./auditGridConfig";
import httpClient from "../../utils/httpClient";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../utils/utils";

const AuditGrid = ({ entityId, width, entityType }) => {
  const dispatch = useDispatch();
  const auditRecords = useSelector((state) => state.audit);
  const constants = useSelector(state => state.constants.data);
  //const tstatuses = new Map(constants.taskStatuses.map(status => [status.id, status.code]));
  //const pstatuses = new Map(constants.resourceStatuses.map(status => [status.id, status.code]));
  const {faultType, vehicleMakes, vehicleModels, taskTypes, vehicleColours} = constants;
  const [loading, setLoading] = useState(true);
  const [paginationModel, setPaginationModel] = useState({page: 0, pageSize: 20});
  
  const parseChanges = (changes) => {
    try {
      const unescaped = JSON.parse(changes);
      return unescaped;
    } catch (err) {
      return null;
    }

  }

  const getAuditData = async () => {
    try {
      const entityUrl = entityType == 'patrol' ? 'patrol' : 'task'
      const res = await httpClient.get(`/audit/${entityUrl}/${entityId}`);
      if (res.status == 200) {
        setLoading(false);

        const auditEntries = [];
        let slicedData = res.data;
        let idCount = 1;
        slicedData.forEach(item => {
          const changesJson = parseChanges(item.changesJson);

          if (!Array.isArray(changesJson)) {

            Object.entries(changesJson).forEach(([key, value]) => {
              let cj = {};
              cj[key] = value;
              if(
                key != 'LockedOn' && 
                key != 'StatusChangedOn' && 
                key != 'AssignedResourceId' && 
                key != 'AssignedOn' &&
                key != 'StatusId' &&
                key != 'LastLatitude' &&
                key != 'LastLongitude' &&
                key != 'IsRecovery'
              ) {
                auditEntries.push({
                  ...item,
                  changesJson: cj,
                  id: idCount++
                });
              }
            });

          } else {

            const parsedItem = {
              ...item,
              changesJson: changesJson,
              id: idCount++
            };
            auditEntries.push(parsedItem);
          }
        });

        const parsed = auditEntries.map(item => {
          const changesJson = item.changesJson;
          const parsedItem = {
            ...item,
            changesJson: changesJson
          };

          let oldValue = '';
          let newValue = '';
          let actionType = '';

          // CREATION & UPDATE
          if (Array.isArray(changesJson)) {
            //CREATION
            if (changesJson[0] == null) {
              parsedItem.oldValue = 'N/A';
              parsedItem.actionType = 'CREATION';
              parsedItem.newValue = { details: changesJson[1] };
              // UPDATE
            } else {
              parsedItem.oldValue = { details: changesJson[0] };
              parsedItem.actionType = 'UPDATE';
              parsedItem.newValue = { details: changesJson[1] };
            }
          } else {
            if (changesJson.LockedBy && changesJson.LockedBy[0]) {
              parsedItem.oldValue = `By: ${changesJson.LockedBy?.[0] || 'N/A'}`;
              parsedItem.actionType = 'LOCK';
              parsedItem.newValue = `By: ${changesJson.LockedBy?.[1] || 'N/A'}`;
            }
            if (changesJson.LockedBy && !changesJson.LockedBy[0]) {
              parsedItem.oldValue = `By: ${changesJson.LockedBy?.[0] || 'N/A'}`;
              parsedItem.actionType = 'UNLOCK';
              parsedItem.newValue = `By: ${changesJson.LockedBy?.[1] || 'N/A'}`;
            }
            if (changesJson.Status) {
              parsedItem.oldValue = changesJson.Status.Code[0];
              parsedItem.actionType = 'STATUS CHANGE';
              parsedItem.newValue = changesJson.Status.Code[1];
            }
            if (changesJson.StatusId) {
              parsedItem.oldValue = changesJson.Status.Code[0];
              parsedItem.actionType = 'STATUS CHANGE';
              parsedItem.newValue = changesJson.Status.Code[1];
            }
            if (changesJson.AssignedPatrol) {
              parsedItem.oldValue = `CallSign: ${changesJson.AssignedPatrol[0]?.Callsign || 'N/A'}`;
              parsedItem.actionType = 'ASSIGNMENT';
              parsedItem.newValue = `CallSign: ${changesJson.AssignedPatrol[1]?.Callsign || 'N/A'}`;
            }
            if (changesJson.CustomerName) {
              parsedItem.oldValue = `Cust. Name: ${changesJson.CustomerName[0]}`;
              parsedItem.actionType = 'UPDATE';
              parsedItem.newValue = `Cust Name: ${changesJson.CustomerName[1]}`;
            }
            if (changesJson.Comments) {
              parsedItem.oldValue = `${changesJson.Comments[0]}`;
              parsedItem.actionType = 'COMMENTS';
              parsedItem.newValue = `${changesJson.Comments[1]}`;
            }
            if (changesJson.CaseId) {
              parsedItem.oldValue = `ID: ${changesJson.CaseId[0]}`;
              parsedItem.actionType = 'CASE ID';
              parsedItem.newValue = `ID: ${changesJson.CaseId[1]}`;
            }
            if (changesJson.RequiresIntervention) {
              parsedItem.oldValue = `${changesJson.RequiresIntervention?.[0] || 'N/A'}`;
              parsedItem.actionType = 'Req. Intervention';
              parsedItem.newValue = `${changesJson.RequiresIntervention?.[1] || 'N/A'}`;
            }
            if (changesJson.InteerventionReason) {
              parsedItem.oldValue = `${changesJson.InteerventionReason?.[0] || 'N/A'}`;
              parsedItem.actionType = 'Req. Intervention';
              parsedItem.newValue = `${changesJson.InteerventionReason?.[1] || 'N/A'}`;
            }
            if (changesJson.InterventionReason) {
              parsedItem.oldValue = `${changesJson.InterventionReason?.[0] || 'N/A'}`;
              parsedItem.actionType = 'Interv. REASON';
              parsedItem.newValue = `${changesJson.InterventionReason?.[1] || 'N/A'}`;
            }
            if (changesJson.TypeId) {
              parsedItem.oldValue = `${taskTypes.find(t => t.id == changesJson.TypeId?.[0])?.key || 'N/A'}`;
              parsedItem.actionType = 'TASK TYPE';
              parsedItem.newValue = `${taskTypes.find(t => t.id == changesJson.TypeId?.[1])?.key || 'N/A'}`;
            }
            if (changesJson.FaultId) {
              parsedItem.oldValue = `${faultType.find(t => t.id == changesJson.FaultId?.[0])?.key || 'N/A'}`;
              parsedItem.actionType = 'FAULT TYPE';
              parsedItem.newValue = `${faultType.find(t => t.id == changesJson.FaultId?.[1])?.key || 'N/A'}`;
            }
            if (changesJson.LocationDescription) {
              parsedItem.oldValue = `${changesJson.LocationDescription[0] || 'N/A'}`;
              parsedItem.actionType = 'BKD. DESC.';
              parsedItem.newValue = `${changesJson.LocationDescription[1] || 'N/A'}`;
            }
            if (changesJson.LocationLatitude) {
              parsedItem.oldValue = `${changesJson.LocationLatitude[0] || 'N/A'}`;
              parsedItem.actionType = 'BKD. LAT';
              parsedItem.newValue = `${changesJson.LocationLatitude[1] || 'N/A'}`;
            }
            if (changesJson.LocationLongitude) {
              parsedItem.oldValue = `${changesJson.LocationLongitude[0] || 'N/A'}`;
              parsedItem.actionType = 'BKD. LNG';
              parsedItem.newValue = `${changesJson.LocationLongitude[1] || 'N/A'}`;
            }
            if (changesJson.RecoveryDestinationLongitude) {
              parsedItem.oldValue = `${changesJson.RecoveryDestinationLongitude[0] || 'N/A'}`;
              parsedItem.actionType = 'RECY LNG';
              parsedItem.newValue = `${changesJson.RecoveryDestinationLongitude[1] || 'N/A'}`;
            }
            if (changesJson.RecoveryDestinationLatitude) {
              parsedItem.oldValue = `${changesJson.RecoveryDestinationLatitude[0] || 'N/A'}`;
              parsedItem.actionType = 'RECY LAT';
              parsedItem.newValue = `${changesJson.RecoveryDestinationLatitude[1] || 'N/A'}`;
            }
            if (changesJson.VehicleMakeId) {
              parsedItem.oldValue = `${vehicleMakes.find(t => t.id == changesJson.VehicleMakeId?.[0])?.code || 'N/A'}`;
              parsedItem.actionType = 'V. BRAND';
              parsedItem.newValue = `${vehicleMakes.find(t => t.id == changesJson.VehicleMakeId?.[1])?.code || 'N/A'}`;
            }
            if (changesJson.VehicleModelId) {
              parsedItem.oldValue = `${vehicleModels.find(t => t.id == changesJson.VehicleModelId?.[0])?.code || 'N/A'}`;
              parsedItem.actionType = 'V. MODEL';
              parsedItem.newValue = `${vehicleModels.find(t => t.id == changesJson.VehicleModelId?.[1])?.code || 'N/A'}`;
            }
            if (changesJson.VehicleRegistrationNumber) {
              parsedItem.oldValue = `${changesJson.VehicleRegistrationNumber[0] || 'N/A'} `;
              parsedItem.actionType = 'V. REG#';
              parsedItem.newValue = `${changesJson.VehicleRegistrationNumber[1] || 'N/A'}`;
            }
            if (changesJson.VehicleColour) {
              parsedItem.oldValue = `${vehicleColours.find(t => t.id == changesJson.VehicleColour?.[0])?.name || 'N/A'}`;
              parsedItem.actionType = 'V. COLOR';
              parsedItem.newValue = `${vehicleColours.find(t => t.id == changesJson.VehicleColour?.[1])?.name || 'N/A'}`;
            }
            if (changesJson.ContactPhoneNumber) {
              parsedItem.oldValue = `${changesJson.ContactPhoneNumber[0] || 'N/A'}`;
              parsedItem.actionType = 'PHONE#';
              parsedItem.newValue = `${changesJson.ContactPhoneNumber[1] || 'N/A'}`;
            }
            if (changesJson.CustomerAddress) {
              parsedItem.oldValue = `${changesJson.CustomerAddress[0] || 'N/A'}`;
              parsedItem.actionType = 'CUST. ADD.';
              parsedItem.newValue = `${changesJson.CustomerAddress[1]}`;
            }
            if (changesJson.CustomerPostcode) {
              parsedItem.oldValue = `${changesJson.CustomerPostcode[0] || 'N/A'}`;
              parsedItem.actionType = 'CUST. PO CODE';
              parsedItem.newValue = `${changesJson.CustomerPostcode[1] || 'N/A'}`;
            }
            if (changesJson.MembershipInfo) {
              parsedItem.oldValue = `${changesJson.MembershipInfo[0] || 'N/A'}`;
              parsedItem.actionType = 'MEMBERSHIP';
              parsedItem.newValue = `${changesJson.MembershipInfo[1] || 'N/A'}`;
            }
            if (changesJson.IsPriority) {
              parsedItem.oldValue = `${changesJson.IsPriority[0] || 'N/A'}`;
              parsedItem.actionType = 'PRIORITY';
              parsedItem.newValue = `${changesJson.IsPriority[1] || 'N/A'}`;
            }
            if (changesJson.IsHomestart) {
              parsedItem.oldValue = `${changesJson.IsHomestart[0] || 'N/A'}`;
              parsedItem.actionType = 'HOMESTART';
              parsedItem.newValue = `${changesJson.IsHomestart[1] || 'N/A'}`;
            }
            if (changesJson.IsHomestart) {
              parsedItem.oldValue = `${changesJson.IsHomestart[0] || 'N/A'}`;
              parsedItem.actionType = 'HOMESTART';
              parsedItem.newValue = `${changesJson.IsHomestart[1] || 'N/A'}`;
            }
            if (changesJson.RecoveryDestinationText) {
              parsedItem.oldValue = `${changesJson.RecoveryDestinationText[0] || 'N/A'}`;
              parsedItem.actionType = 'RECY Desc.';
              parsedItem.newValue = `${changesJson.RecoveryDestinationText[1] || 'N/A'}`;
            }
            if(changesJson.AssignedSupplier) {
              parsedItem.oldValue = `${changesJson.AssignedSupplier[0]?.ResourceId || 'N/A'}`;
              parsedItem.actionType = 'GARAGE ASSIG.';
              parsedItem.newValue = `${changesJson.AssignedSupplier[1]?.ResourceId || 'N/A'}`;
            }

            if (entityType == 'patrol') {

              if (changesJson.PhoneNumber) {
                oldValue = `${changesJson.PhoneNumber[0]} `;
                actionType = 'Phone/';
                newValue = `${changesJson.PhoneNumber[1]} `;
              }
              if (changesJson.Status) {
                oldValue = changesJson.Status.Code[0];
                actionType = 'STATUS';
                newValue = changesJson.Status.Code[1];
              }
              if (changesJson.Mask) {
                //@TODO probably incorrect - what is old value?
                oldValue = changesJson.Mask[0];
                actionType = 'Type/';
                newValue = changesJson.Mask[1];
              }
              if (changesJson.ManualUvorUntil) {
                oldValue = formatDate(changesJson.ManualUvorUntil[0]);
                actionType = 'UVOR/';
                newValue = formatDate(changesJson.ManualUvorUntil[1]);
              }
              
              parsedItem.oldValue = oldValue;
              parsedItem.newValue = newValue;
              parsedItem.actionType = actionType;

            }
          }
          return parsedItem;
        });

        dispatch({
          type: 'audit/setAudit',
          payload: parsed
        });
      }
    } catch (error) {
      console.error("Audit error:", error)
    }
  }

  useEffect(() => {
    getAuditData();
  }, []);

  return (
    <DataGrid
      sx={{ width: width || 0.9 }}
      loading={loading}
      rows={auditRecords || {}}
      columns={getAuditColumns()}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
      }
      initialState={{
        sorting: { sortModel: [{ field: 'changedAt', direction: 'asc' }] }
      }}
      pagination
      paginationModel= {paginationModel}
      onPaginationModelChange={setPaginationModel}
      pageSizeOptions={[10, 20, 50]}
      disableColumnResize
      density="compact"
      slotProps={{
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: "outlined",
              size: "small",
            },
            columnInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            operatorInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: "outlined",
                size: "small",
              },
            },
          },
        },
      }}
    />
  );
}

export default AuditGrid;